import React, { useState } from 'react'
import useForm from "../../services/useForm";
import validate from '../../services/validations/recoveryPasswordFormValidationRules';

import { Header } from '../../components/Header'
import { Footer } from '../../components/Footer'

export const RecoveryPassword = () => {
    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(login, validate);

    const [success, setSuccess] = useState(false);
    const [hasErrors, setHasErrors] = useState(false);
    const [errorMessages, setErrorMessages] = useState('');

    function goSitters() {
        window.location.href = '/list';
    }

    function showDefaultErrorMessage(){
        setErrorMessages('Ha ocurrido un error inesperado, por favor vuelva a intentarlo.')
        setHasErrors(true);
    }

    function login() {
        fetch(process.env.REACT_APP_API_URL + "/Auth/recoveryPassword", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email: values.email })
        })
        .then((response) => {
            debugger;
            if (response.ok) {
                setSuccess(true);
            }
            else {
                if (response.status === 500) {
                    showDefaultErrorMessage();
                }
                else {
                    response.json().then(data => {
                        data.errors.forEach((error) => {
                            if (error === 'UserNotFound') {
                                setErrorMessages('El email ingresado no existe.')
                                setHasErrors(true);
                            }
                        })
                    });
                }

                setSuccess(false);
            }
        })
        .catch(function (error) {
            showDefaultErrorMessage();
        });
    }

    return (
        <>
            <Header />
            {!success &&
                <div id="sign-in-dialog" className="zoom-anim-dialog">
                    <div className="small-dialog-header">
                        <h3>¿Has olvidado tu contraseña?</h3>
                    </div>
                    <br />
                    {hasErrors &&
                        <div className="notification error closeable">
                            <p>{errorMessages}</p>
                        </div>
                    }
                    <div className="sign-in-form style-1">
                        <form onSubmit={handleSubmit} className="login" noValidate>
                            <p className="form-row form-row-wide">
                                <label>No pasa nada. Escribre tu dirección de email para poder reestablecer tu contraseña</label>
                                <label for="username">Email:
                                <i className="im im-icon-Male"></i>
                                    <input type="email" className={`input ${errors.email && 'is-danger'}`} name="email" onChange={handleChange} value={values.email || ''} required />
                                </label>
                                {errors.email && (
                                    <p className="help is-danger">{errors.email}</p>
                                )}
                            </p>
                            <div className="form-row right">
                                <input type="submit" className="button border margin-top-5" name="login" value="Reestablecer tu contraseña" />
                            </div>
                        </form>
                    </div>
                </div>
            }
            { success &&
                <div id="sign-in-dialog" className="zoom-anim-dialog">
                    <div className="row">
                        <div className="col-md-12">

                            <h3>Petición enviada correctamente</h3>

                            <div className="notification success closeable">
                                <h4>Te hemos enviado un email para puedas recuperar tu contraseña.
                                Si no lo encuentras en tu bandeja de entrada, revisa en la carpeta de spam.
                                    <br /> <br /> Si al cabo de unos minutos no recibes el email, escribenos a <strong>soporte@gamarreando.es</strong></h4>
                            </div>


                        </div>
                        <div className="col-md-12">
                            <button className="button" onClick={goSitters}>Buscar vendedores</button>
                        </div>
                    </div>
                </div>
            }
            <Footer />
        </>
    )
}